import {type DataRouterFilePagePayload, isFileOverviewPayload} from '@github-ui/code-view-types'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {getQueryClient} from '@github-ui/react-core/query-client'
import {useMatches} from '@github-ui/react-router'

import {codeViewRepoRoute} from '../routes/code-view-repo-route'
import {codeViewTreeRoute} from '../routes/code-view-tree-route'

/**
 * Determines if the current view is an overview page.
 */
export function useIsOverview() {
  const matches = useMatches()
  const overviewMatch = matches.some(match => match.id === codeViewRepoRoute.id)
  const treeQueryKey = useRouteQueryKey(codeViewTreeRoute, 'mainQuery')

  // Repo route is always overview
  if (overviewMatch) return true

  // Tree route - check payload type from query cache
  if (treeQueryKey) {
    const queryClient = getQueryClient()
    const data = queryClient.getQueryData(treeQueryKey) as {payload: DataRouterFilePagePayload}
    return data ? isFileOverviewPayload(data.payload) : false
  }

  return false
}
